import React from 'react';

import styels from './index.less';

const WhiteBox = ({ children, className = '' }) => {
  return (
    <div className={`${styels.wrap} ${className}`}>
      {children}
    </div>
  );
};

export default WhiteBox;
